const alphabetizer = (a: string, b: string) => a > b ? 1 : -1;

export default alphabetizer;